// extracted by mini-css-extract-plugin
export default {"mobileOptions":"MobileOptions_mobileOptions__Y9G+w","callSection":"MobileOptions_callSection__q2Pxw","whatsappSection":"MobileOptions_whatsappSection__81lMj"};